import { type GlobalSearchRecentItem } from '../../../value-objects/GlobalSearchRecentItem'
import { type IGlobalSearchRecentsRepository } from '../../interfaces/IGlobalSearchRecentsRepository'

interface Dependency {
  recentsRepository: IGlobalSearchRecentsRepository
}

export class GetGlobalSearchRecentItemsUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (): GlobalSearchRecentItem[] => {
    const allRecents = this.deps.recentsRepository.getAll()

    return allRecents.filter((item) => !item.isExpired)
  }
}
